<template>
  <v-sheet 
    outlined 
    min-height="80vh"
    class="d-flex justify-center align-center in-progress">
    <v-row class="text-center">

      <v-col 
        cols="12" 
        v-if="$vuetify.breakpoint.xsOnly">
        <h2 class="font-weight-regular text--secondary pl-8 pr-8">
          Convocatoria de proyectos para las <b>{{ edition.edition.short_name }}</b>
        </h2>
      </v-col>

      <v-col 
        cols="12" 
        class="headline text--secondary pl-4 pr-4"
        v-if="!$vuetify.breakpoint.xsOnly">
        Convocatoria de proyectos para las <b>{{ edition.edition.short_name }}</b>
      </v-col>

      <v-col cols="12" class="mb-8 pl-8 pr-8">
        <v-img 
          v-if="imageLoaded" 
          :src="imageUrl" 
          contain
          height="340"
          alt="Rocket GIF"
        />

        <p class="subheading font-weight-regular pt-8 pa-4 text--secondary">
          ¡Gracias por ser parte!
          <br>La propuesta enviada está en evaluación.
          <br>Pronto acercaremos una respuesta.
        </p>
      </v-col>

      <v-col cols="12" class="mb-1">
        <v-btn color="red" dark large to="/convocation">
          <v-icon>mdi-arrow-up-circle-outline</v-icon> 
          Mi Convocatoria
        </v-btn>
      </v-col>

    </v-row>
  </v-sheet>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'entrepreneurEmpty',

  data: () => ({
    loading:false,
    rocket:null,

    imageUrl: require('@/assets/icons/gif_jije.gif'),
    imageLoaded: false,

    time_left:null,
    end: null
  }),
  computed: {
    ...mapGetters([ 
        'convocation_form', 'edition'
    ])
  },
  mounted() {
    const image = new Image();
    image.onload = () => {
      this.imageLoaded = true;
      
    };
    image.src = this.imageUrl;
  }
}
</script>
<style scoped>
.in-progress{
  padding-top: 82px;
  padding-bottom: 82px;
}
</style>